import { render } from "./BannerAnalytics.vue?vue&type=template&id=bb42bafa"
import script from "./BannerAnalytics.vue?vue&type=script&lang=js"
export * from "./BannerAnalytics.vue?vue&type=script&lang=js"

import "./BannerAnalytics.vue?vue&type=style&index=0&id=bb42bafa&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__